"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalLibraryRepository = void 0;
const lodash_1 = require("lodash");
const Permission_1 = require("./Permission");
const FailedToFetchGlobalLibraryAccessTokens_1 = require("../errors/FailedToFetchGlobalLibraryAccessTokens");
const Repository_1 = require("./Repository");
const FailedToUpdateGlobalLibrary_1 = require("../errors/FailedToUpdateGlobalLibrary");
class GlobalLibraryRepository {
    constructor(vizzly) {
        this.vizzly = vizzly;
        this.repo = new Repository_1.Repository('id');
    }
    createGlobalLibrary(createParams) {
        return __awaiter(this, void 0, void 0, function* () {
            const vizzlyApi = this.vizzly.getVizzlyAPI();
            let globalLibrary;
            if (this.vizzly.implementationStrategy.shouldPersistViaQueryEngine()) {
                const vizzlyQueryEngineApi = this.vizzly.getVizzlyQueryEngineAPI();
                globalLibrary = yield vizzlyQueryEngineApi.createGlobalLibrary(createParams);
            }
            else {
                globalLibrary = yield vizzlyApi.createGlobalLibrary(createParams);
            }
            globalLibrary.global_library = GlobalLibraryRepository.upcast(globalLibrary.global_library);
            this.repo.addItem(globalLibrary.global_library, globalLibrary.permissions);
            return globalLibrary;
        });
    }
    fetchGlobalLibraries(params) {
        return __awaiter(this, void 0, void 0, function* () {
            // Now, we fetch the libraries and the access tokens from the access call.
            return yield this.fetchGlobalLibraryAccessTokens(params);
        });
    }
    fetchGlobalLibraryAccessTokens(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const vizzlyApi = this.vizzly.getVizzlyAPI();
            let accessTokens;
            if (!this.repo.isPopulated()) {
                if (this.vizzly.implementationStrategy.shouldPersistViaQueryEngine()) {
                    const vizzlyQueryEngineApi = this.vizzly.getVizzlyQueryEngineAPI();
                    accessTokens = yield vizzlyQueryEngineApi.fetchGlobalLibraryAccessTokens(params);
                }
                else {
                    accessTokens = yield vizzlyApi.fetchGlobalLibraryAccessTokens(params);
                }
                if (accessTokens.status === 200) {
                    const formattedPermissions = accessTokens.body.permissions.map(Permission_1.Permission.formatGlobalLibraryPermission);
                    this.repo.initRepo(accessTokens.body.global_libraries.map(GlobalLibraryRepository.upcast), formattedPermissions);
                }
                else {
                    throw new FailedToFetchGlobalLibraryAccessTokens_1.FailedToFetchGlobalLibraryAccessTokens('Failed to load access tokens for the global library.');
                }
            }
            return {
                global_libraries: this.repo.getRepo().storedItems,
                permissions: this.repo.getRepo().permissions,
            };
        });
    }
    updateGlobalLibrary(params) {
        return __awaiter(this, void 0, void 0, function* () {
            let updateResponse;
            const vizzlyApi = this.vizzly.getVizzlyAPI();
            if (this.vizzly.implementationStrategy.shouldPersistViaQueryEngine()) {
                const vizzlyQueryEngineApi = this.vizzly.getVizzlyQueryEngineAPI();
                updateResponse = yield vizzlyQueryEngineApi.updateGlobalLibrary(params);
            }
            else {
                updateResponse = yield vizzlyApi.updateGlobalLibrary(params);
            }
            if (updateResponse.status != 200) {
                throw new FailedToUpdateGlobalLibrary_1.FailedToUpdateGlobalLibrary(`Failed to update the global library ${updateResponse.status}`);
            }
            const globalLibrary = GlobalLibraryRepository.upcast(updateResponse.body.global_library);
            this.repo.updateItem(globalLibrary);
            return globalLibrary;
        });
    }
    getChildGlobalLibrariesByParentGlobalLibraryId(parentGlobalLibraryId) {
        return __awaiter(this, void 0, void 0, function* () {
            const { global_libraries: globalLibraries } = yield this.fetchGlobalLibraries();
            return GlobalLibraryRepository.mapParentToChildGlobalLibraries(globalLibraries)[parentGlobalLibraryId] || [];
        });
    }
    static splitParentAndChildGlobalLibraries(globalLibraries) {
        let childGlobalLibraries = [];
        let parentGlobalLibraries = [];
        globalLibraries.forEach((gL) => {
            if (gL.parent_global_library_id === null) {
                parentGlobalLibraries = [...parentGlobalLibraries, gL];
            }
            else {
                childGlobalLibraries = [...childGlobalLibraries, gL];
            }
        });
        return { childGlobalLibraries, parentGlobalLibraries };
    }
    /**
     * Takes a list of global libraries, and returns a mapping of parent global
     * library to a list of it's children
     */
    static mapParentToChildGlobalLibraries(globalLibraries) {
        let mapping = {};
        (0, lodash_1.cloneDeep)(globalLibraries).forEach((globalLibrary) => {
            if (globalLibrary.parent_global_library_id !== null) {
                // Child library
                // Ensure the parent has been setup
                if (!mapping[globalLibrary.parent_global_library_id])
                    mapping[globalLibrary.parent_global_library_id] = [];
                // Add the child to the parent's list of children
                mapping[globalLibrary.parent_global_library_id] = [
                    ...mapping[globalLibrary.parent_global_library_id],
                    globalLibrary,
                ];
            }
        });
        return mapping;
    }
    static upcast(globalLibrary) {
        return Object.assign(Object.assign({}, globalLibrary), { library: Object.assign({ views: [], customFields: {} }, (globalLibrary.library || {})) });
    }
}
exports.GlobalLibraryRepository = GlobalLibraryRepository;
